import React from "react";

interface Props {
  className?: string;
  as?: string;
  loading: boolean;
}

const DotsFallback: React.FC<Props> = ({
  className,
  loading,
  children,
  ...otherProps
}) => (
  <div className={className} {...otherProps}>
    {loading ? "..." : children}
  </div>
);

export default DotsFallback;
